/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArticleCreateRequest } from '../models/ArticleCreateRequest';
import type { ArticleResponse } from '../models/ArticleResponse';
import type { ArticleUpdateRequest } from '../models/ArticleUpdateRequest';
import type { PaginatedResponse } from '../models/PaginatedResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ArticleService {
    /**
     * Download Articles Excel
     * 워크스페이스의 회의록을 엑셀로 일괄 다운로드
     * @returns any OK
     * @throws ApiError
     */
    public static appsArticleViewsDownloadArticlesExcel({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/article/excel/download',
            query: {
                'workspace_id': workspaceId,
            },
        });
    }
    /**
     * Create Article
     * 게시글 생성
     *
     * 새로운 게시글을 생성합니다.
     * @returns ArticleResponse Created
     * @throws ApiError
     */
    public static appsArticleViewsCreateArticle({
        requestBody,
    }: {
        requestBody: ArticleCreateRequest,
    }): CancelablePromise<ArticleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/article',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Articles
     * 게시글 목록 조회 및 검색
     *
     * 워크스페이스 내 게시글을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * q: 검색 키워드 (선택사항) - 제목, 내용, 작성자명으로 검색
     * article_type: 게시글 타입 (선택사항)
     * creator_id: 작성자 ID (선택사항)
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse OK
     * @throws ApiError
     */
    public static appsArticleViewsListArticles({
        workspaceId,
        q,
        articleType,
        creatorId,
        page = 1,
        perPage = 100,
    }: {
        workspaceId: string,
        q?: string,
        articleType?: string,
        creatorId?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/article',
            query: {
                'workspace_id': workspaceId,
                'q': q,
                'article_type': articleType,
                'creator_id': creatorId,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Article
     * 게시글 조회
     *
     * ID로 특정 게시글을 조회합니다.
     * @returns ArticleResponse OK
     * @throws ApiError
     */
    public static appsArticleViewsGetArticle({
        articleId,
    }: {
        articleId: string,
    }): CancelablePromise<ArticleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/article/{article_id}',
            path: {
                'article_id': articleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Article
     * 게시글 정보 수정
     *
     * 특정 게시글의 정보를 수정합니다.
     * @returns ArticleResponse OK
     * @throws ApiError
     */
    public static appsArticleViewsUpdateArticle({
        articleId,
        requestBody,
    }: {
        articleId: string,
        requestBody: ArticleUpdateRequest,
    }): CancelablePromise<ArticleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/article/{article_id}',
            path: {
                'article_id': articleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Article
     * 게시글 삭제
     *
     * 특정 게시글을 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsArticleViewsDeleteArticle({
        articleId,
    }: {
        articleId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/article/{article_id}',
            path: {
                'article_id': articleId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
